import React from 'react'
import {RESPONSIVE_WIDTH} from './constants'

export default function useWindowSize() {
  const isSSR = typeof window === 'undefined'
  const [windowSize, setWindowSize] = React.useState({
    isMediaMobile: isSSR ? false : window.innerWidth < RESPONSIVE_WIDTH,
    isMediaScreen: isSSR ? true : window.innerWidth >= RESPONSIVE_WIDTH,
  })

  function changeWindowSize() {
    setWindowSize({
      isMediaMobile: window.innerWidth < RESPONSIVE_WIDTH,
      isMediaScreen: window.innerWidth >= RESPONSIVE_WIDTH,
    })
  }

  React.useEffect(() => {
    window.addEventListener('resize', changeWindowSize)

    return () => {
      window.removeEventListener('resize', changeWindowSize)
    }
  }, [])

  return windowSize
}
